<template>
    <div class="note-body">
        <div v-if="collapsible && expand && !options.expandNotes && noteText && (noteText.length > 500 || newLines() > 10)">
            <a @click="toggleFullNote" class="full-note-toggle">
                <span><i class="fa fa-minus"></i>Hide Full Note</span>               
            </a>
        </div>
        <div v-html="formattedNote"></div>
        <div v-if="collapsible && !options.expandNotes && noteText && (noteText.length > 500 || newLines() > 10)">
            <a @click="toggleFullNote" class="full-note-toggle">
                <span v-if="expand"><i class="fa fa-minus"></i>Hide</span>
                <span v-else><i class="fa fa-plus"></i>Show</span>
                Full Note
            </a>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import nl2br from 'nl2br';
    import ellipsize from 'ellipsize';
    import { hilight } from '../../_shared/search-utils.js';

    export default {
        data: function () {
            return {
                expand: !this.collapsible,
                options: this.$store.state.searchFilter
            };
        },
        props: {
            noteText: String,
            collapsible: Boolean,
            teComment: String,
            excludeRE: Boolean
        },
        methods: {
            toggleFullNote(e) {
                this.expand = !this.expand;
            },
            tidyText: function () {
                let noteText = this.noteText;
                if (noteText !== null) {
                    // Account for # of characters <br> adds to RE so it's properly removed from the beginning of note later
                    if (this.excludeRE) {
                        noteText = noteText.substring(this.teComment.length);
                    }
                    // remove some extra newline characters
                    return noteText
                        .replace(/\t/g, " ")
                        .replace(/\r\n/g, "\n")
                        .replace(/  \n/g, "\n")
                        .replace(/ \n/g, "\n")
                        .replace(/\n\n\n\n\n/g, "\n\n")
                        .replace(/\n\n\n/g, "\n\n")
                        .replace(/\n\n\n/g, "\n\n");
                } else {
                    return "";
                }
            },
            newLines: function () {
                if (this.noteText) {
                    return this.noteText.split('\n').length - 1;
                } else {
                    return 0;
                }
            }
        },
        computed: {
            formattedNote: function () {
                let noteText = this.tidyText();

                if (!this.options.expandNotes && !this.expand && noteText && (noteText.length > 500 || this.newLines() > 10)) {
                    noteText = ellipsize(noteText, 450);
                    noteText = noteText.replace(/\</g, "&lt;").replace(/\?\?\?\?/g, "");
                }
                else {
                    noteText = noteText.replace(/\</g, "&lt;").replace(/\?\?\?\?/g, "");
                    noteText = nl2br(noteText, false);
                }



                // Exclude RE from beginning of Note when email not being sent for TE and not Outlook TE
                return hilight(noteText, this.options.searchText);
            }
        }
    };
</script>